import Vue from 'vue'
import Router from 'vue-router'
import {
  About,
  Callback,
  Legal,
  PendingRegistration,
  QueryEdit
} from '@/components/'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: QueryEdit,
      props: {showDefaultQuery: true}
    },
    {
      path: '/query/:id?',
      name: 'Query',
      component: QueryEdit,
      props: true
    },
    {
      path: '/new-query/:importId',
      name: 'New Query Import',
      component: QueryEdit,
      props: true
    },
    {
      path: '/callback',
      component: Callback
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/legal',
      name: 'Legal',
      component: Legal
    },
    {
      path: '/pending-registration',
      name: 'PendingRegistration',
      component: PendingRegistration
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js